import { Spinner } from '@restworld/ui-ds-base';
export const WorkerDataLoader = () => {
  return (
    <div className="flex flex-col items-center w-full">
      <Spinner color="primary" size="md" />
    </div>
  );
};
